import { render, staticRenderFns } from "./BrandSetupToolbar.vue?vue&type=template&id=78acc53b&"
import script from "./BrandSetupToolbar.vue?vue&type=script&lang=js&"
export * from "./BrandSetupToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports